
export default function Location() {
  return (
    <section id="location" className="py-24 bg-gradient-to-br from-teal-50 via-cyan-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl shadow-lg">
              <i className="ri-map-pin-line text-5xl text-white"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
              موقع مطعم فوكاتشيا
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-teal-500 to-cyan-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-700 leading-relaxed mb-12">
              يقع مطعم فوكاتشيا في الطابق الأرضي من الفندق، مما يوفر لك سهولة الوصول والاستمتاع بأجواء راقية. الكافي والمطعم مفتوحان على مدار ٢٤ ساعة لخدمتكم.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-teal-400 to-teal-500 rounded-xl flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Cairo, sans-serif' }}>
                      الموقع داخل الفندق
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      يقع المطعم في الطابق الأرضي من الفندق، بجوار اللوبي الرئيسي، مما يسهل الوصول إليه من جميع أجنحة الفندق
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-green-400 to-green-500 rounded-xl flex-shrink-0">
                    <i className="ri-time-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Cairo, sans-serif' }}>
                      أوقات العمل
                    </h3>
                    <div className="space-y-2 text-gray-700">
                      <p><span className="font-semibold">بوفيه الفطور:</span> 6:30 ص - 11:00 ص</p>
                      <p><span className="font-semibold">الكافي والمطعم:</span> ٢٤ ساعة يومياً</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-amber-400 to-amber-500 rounded-xl flex-shrink-0">
                    <i className="ri-wheelchair-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Cairo, sans-serif' }}>
                      سهولة الوصول
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      المطعم مجهز بمداخل ومرافق مناسبة لذوي الاحتياجات الخاصة، مع مصاعد حديثة تربط جميع طوابق الفندق
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-red-500 rounded-full mb-6 mx-auto">
                  <i className="ri-time-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  ساعات العمل
                </h3>
                <div className="text-center space-y-2">
                  <p className="text-gray-700 font-semibold">بوفيه الفطور: 6:30 ص - 11:00 ص</p>
                  <p className="text-gray-700 font-semibold">الكافي والمطعم: ٢٤ ساعة يوميًا</p>
                </div>
              </div>

              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-red-500 to-pink-500 rounded-full mb-6 mx-auto">
                  <i className="ri-car-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  معلومات هامة
                </h3>
                <div className="text-center">
                  <p className="text-orange-600 font-semibold">لا تتوفر خدمة صف السيارات</p>
                  <p className="text-gray-600 text-sm mt-2">يرجى استخدام مواقف السيارات العامة القريبة</p>
                </div>
              </div>
            </div>

            <div className="relative h-full min-h-[600px]">
              <div className="absolute inset-0 bg-gradient-to-br from-teal-400/20 to-cyan-400/20 rounded-3xl transform rotate-3"></div>
              <div className="relative h-full rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/28fa85fc7346258cbdf0652a8e584b3d.jpg"
                  alt="موقع المطعم في الفندق"
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-8">
                  <div className="flex items-center gap-3 text-white">
                    <i className="ri-map-pin-fill text-3xl"></i>
                    <div>
                      <p className="text-lg font-semibold">الطابق الأرضي</p>
                      <p className="text-sm opacity-90">بجوار اللوبي الرئيسي</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 bg-white rounded-2xl p-8 shadow-lg">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl">
                  <i className="ri-phone-line text-3xl text-white"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-600">للحجز والاستفسار</p>
                  <p className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
                    اتصل بنا الآن
                  </p>
                </div>
              </div>
              <button
                onClick={() => {
                  const element = document.getElementById('reservation');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="px-8 py-4 bg-gradient-to-r from-teal-500 to-cyan-600 text-white font-bold rounded-xl hover:from-teal-600 hover:to-cyan-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                احجز طاولتك الآن
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
